export const parseCSV = (csvText: string): { [key: string]: string }[] => {
    const lines = csvText.split('\n');
    const headers = lines[0].split(',');
    return lines.slice(1).map(line => {
        const values = line.split(',');
        const obj: { [key: string]: string } = {};
        headers.forEach((header, index) => {
            if (values[index] !== undefined) {
                obj[header.trim()] = values[index].trim();
            }
        });
        // objのキー数がheadersの長さより短い場合は追加しない
        if (Object.keys(obj).length === headers.length) {
            return obj;
        }
        return null;
    }).filter(obj => obj !== null); // nullを除外
};

/**
 * CSVデータを配列に変換する関数
 * @param csvText - CSVデータの文字列
 * @returns 配列形式のデータ
 */
export const parseCsvToArray = (csvText: string): {[key: string]: string}[] => {
    const lines = csvText.trim().split('\n');
    const headers = lines[0].split(',');
  
    return lines.slice(1).map(line => {
      const values = line.split(',');
      const record: {[key: string]: string} = {};
      headers.forEach((header, index) => {
        record[header.trim()] = values[index] ? values[index].trim() : ''; // undefinedの場合は空文字列を設定
      });
      return record;
    });
};
